import React from 'react';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../../util/translationUtility';
import { onProductResultClick } from '../../Infrastructure/gtm';
import ProductTileVariation from './ProductTileVariation';
import ProductTileAddToListLink from './ProductTileAddToListLink';
import withImportantStyle from 'react-with-important-style';
import addToCartLoginModalClient from '../../../util/addToCartLoginModalClient';
import IconWithTooltip from '../../../SharedComponents/General/IconWithTooltip';
import { generateLoginPageWithReturnUrlLink } from '../../../util/loginPageLinkUtility';

const CustomTd = withImportantStyle('td');

class ProductTileWithVariations extends React.PureComponent {
    constructor(props) {
        super(props);
        if (props.Variations && props.Variations.length > 0) {
            const defaultVariation = props.Variations[0];
            this.DefaultVariationStepQuantity = defaultVariation.EnforceCaseCount ? defaultVariation.CaseCount : 1;
            this.DefaultVariationMinimumOrderQuantity = Math.max(defaultVariation.MinimumOrderQuantity, this.DefaultVariationStepQuantity);
            this.Quantity = !!defaultVariation.quantity ? Math.max(defaultVariation.quantity, this.DefaultVariationMinimumOrderQuantity) : this.DefaultVariationMinimumOrderQuantity;
        }
        this.WishlistVariations = this.getVariationsForWishlists();
        this.state = {
            quantity: this.Quantity,
            showAddedIcon: false,
            showMore: false,
            addToCartLoginLink: props.loginPageUrl
        };

    }

    componentDidMount() {
        if (window?.location) {
            const urlParams = new URLSearchParams(window.location.search);
            const openModalImmediately = !!urlParams.get('addtolist') || false;
            if (openModalImmediately) {
                const variation = this.props.Variations && this.props.Variations.length > 0 && this.props.Variations.find((v) => v.MasterItemNumber == urlParams.get('min'))
                if (variation) {
                    this.props.toggleAddToListModal(true, variation, this.props.isUserLoggedIn);
                    urlParams.delete('addtolist');
                    urlParams.delete('min');
                    let newUrl = window.location.href.replace(window.location.search, '') + "?" + urlParams.toString();
                    window.history.replaceState({ path: newUrl }, '', newUrl);
                }
            }
            const autoAddToCart = !!urlParams.get('addtocart') || false;
            if (autoAddToCart) {
                const variation = this.props.Variations && this.props.Variations.length > 0 && this.props.Variations.find((v) => v.MasterItemNumber == urlParams.get('min'))
                if (variation) {
                    this.onAddToCart(variation, this.state.quantity, this.onAddToCartSuccess);
                    urlParams.delete('addtocart');
                    urlParams.delete('min');
                    let newUrl = window.location.href.replace(window.location.search, '') + "?" + urlParams.toString();
                    window.history.replaceState({ path: newUrl }, '', newUrl);
                }
            }

            this.updateAddToCartLoginLink();
        }
    }

    defaultVariationValidQuantity = (quantityInput) => {
        const parsed = parseInt(quantityInput);
        return !isNaN(parsed) && parsed >= this.DefaultVariationMinimumOrderQuantity && parsed % this.DefaultVariationStepQuantity == 0;
    }

    handleQuantityChange = (event) => {
        this.setState({ quantity: parseInt(event.target.value) });
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (window.innerWidth < 992) {
                event.target.blur();
            } else {
                this.onAddToCart(this.props.Variations[0], this.state.quantity, this.onAddToCartSuccess);
            }
        }
    }

    addToCart = (variation, quantity, onSuccess) => {
        if (addToCartLoginModalClient.displayAddToCartLoginModal()) return;

        window.addToCart(
            variation.Code,
            quantity,
            this.props.addToCartEndPoint,
            variation.GoogleTagManagerProductFieldObject)
            .then(data => {
                //console.log(data);
                if (!!onSuccess) onSuccess();
            }).catch(error => {
                //console.log(error);
            });
    }

    onAddToCartSuccess = () => {
        this.setState({
            quantity: this.DefaultVariationMinimumOrderQuantity
        });
    }

    onAddToCart = (variation, quantity, onSuccess) => {
        if (this.props.onClick) {
            this.props.onClick().then(() => {
                this.addToCart(variation, quantity, onSuccess)
            }).catch((error) => {
                //console.log(error);
                this.addToCart(variation, quantity, onSuccess)
            })
        } else {
            this.addToCart(variation, quantity, onSuccess);
        }
    }

    updateUrl = (link) => window.location.href = link;

    onProductClick = (e, variation) => {
        onProductResultClick(variation.GoogleTagManagerProductFieldObject, this.props.listName);
        if (this.props.onClick) {
            e.preventDefault();
            this.props.onClick().then(() => {
                this.updateUrl(variation.Link);
            }).catch((error) => {
                //console.log(error);
                this.updateUrl(variation.Link);
            })
        }
    }

    toggleShowMore = () => {
        this.setState((prevState) => { return { showMore: !prevState.showMore }; })
    }

    getVariationsForWishlists = () => {
        let wishlistVariations = {};
        for (let i = 0; i < this.props.Variations.length; i++) {
            wishlistVariations[this.props.Variations[i].Code] = {
                DisplayName: this.props.Variations[i].Name,
                SKU: this.props.Variations[i].SKU
            };
        }
        return wishlistVariations;
    }

    getDefaultVariation = () => {
        return !!this.props.Variations && this.props.Variations.length > 0
            ? this.props.Variations[0]
            : {
                Link: this.props.Link,
                Code: null,
                ShowInventoryAvailable: false,
                HidePrice: true,
                CanAddToCart: false
            };
    }

    updateAddToCartLoginLink = () => {
        // This is a slight hack to re-render the login link client-side after server-side rendering
        if (!this.props.isUserLoggedIn) {
            let defaultVariation = this.getDefaultVariation();
            const upToDateLoginLink = generateLoginPageWithReturnUrlLink(this.props.loginPageUrl, defaultVariation.MasterItemNumber, undefined, true);
            if (this.state.addToCartLoginLink !== upToDateLoginLink) {
                this.setState({ addToCartLoginLink: upToDateLoginLink });
            }
        }
    }

    render() {
        const {
            Name,
            Link,
            Image,
            Description,
            IsTestingOrTestingStandaloneProduct,
            ProceedLink,
            HidePricing,
            HasMultipleVariations,
            FeaturedAttributes,
            RestrictedShipToAreas,
            DefaultVariationCode,
            Variations,
            wishlistData,
            toggleAddToListModal,
            loginPageUrl,
            isUserLoggedIn,
            isOrderRequestOnlyMarket
        } = this.props;

        const {
            quantity,
            showMore
        } = this.state;

        let defaultVariation = this.getDefaultVariation();
        const showVariations = HasMultipleVariations && !IsTestingOrTestingStandaloneProduct;

        const hideInventory = !Variations.find((v) => v.ShowInventoryAvailable);
        const hidePrices = HidePricing || !Variations.find((v) => !v.HidePrice);

        const imageStyle = Image.Url && Image.Url !== "null" ? { 'backgroundImage': 'url(' + Image.Url + ')' } : {};
        const validInput = this.defaultVariationValidQuantity(quantity);

        const screenWidth = window
            ? (window.innerWidth > 0)
                ? window.innerWidth
                : window.screen
                    ? window.screen.width
                    : 0
            : 0;
        const isMobile = screenWidth < 768;
        const variationsToShow = isMobile ? 1 : 3;

        // If any variation has a minimum order quantity or case count, we want to move the add to cart button to a new line
        // on smaller screens for all variations. We show some text in those cases and it would make the row too long.
        const addToCartBreakpoint = showVariations && !hideInventory && !hidePrices
            && Variations.some(v => v.MinimumOrderQuantity > 0 || v.EnforceCaseCount) ? "xl" : "md";

        //Use variable for reused logic
        const canAddToCart = defaultVariation.CanAddToCart && !IsTestingOrTestingStandaloneProduct;

        const qtyClassSelector = "qty-option-" + defaultVariation.Code;
        const qtyClassName = "featured-product-with-variations__count " + qtyClassSelector;
        const qtyBoxId = "quanitityBox-" + defaultVariation.SKU + "_" + defaultVariation.Code;

        const hasCatalogNumbers = Variations.filter(v => !!v.CatalogNumber).length > 0;

        return (
            <div className="featured-product-with-variations">
                <div className="featured-product-with-variations__header">
                    <div className="container no-gutters">
                        <div className="row">
                            <div className="col-auto px-0">
                                <a href={Link} title={Name} onClick={(e) => this.onProductClick(e, defaultVariation)} aria-label={Name}>
                                    <div className="featured-product-with-variations__image" style={imageStyle} />
                                </a>
                            </div>
                            <div className="col">
                                <div className="featured-product-with-variations__body">
                                    <a className="featured-product-with-variations__title heading-sm" href={Link} onClick={(e) => this.onProductClick(e, defaultVariation)}
                                        dangerouslySetInnerHTML={{ __html: Name }} />

                                    {!showVariations && !!defaultVariation.Code &&
                                        (!!defaultVariation.CatalogNumber
                                            ? <div className="featured-product-with-variations__code text-sm">
                                                {translateResourceString("/Shared/Products/ErpItemNumberLabel")} {defaultVariation.SKU}
                                                &nbsp;|&nbsp;{translateResourceString("/Shared/Products/CatalogNumberLabel")} {defaultVariation.CatalogNumber}
                                            </div>
                                            : <div className="featured-product-with-variations__code text-sm">
                                                {translateResourceString("/Shared/Products/ErpItemNumberLabel")} {defaultVariation.SKU}
                                            </div>
                                        )
                                    }
                                    {!!Description && <div className="featured-product-with-variations__text d-none d-md-block" dangerouslySetInnerHTML={{ __html: Description }} />}
                                    {!!FeaturedAttributes && !!FeaturedAttributes.length &&
                                        <div className="featured-product-with-variations__attributes d-none d-md-block">
                                            {FeaturedAttributes.map(attr =>
                                            (attr.Value !== null && <div key={attr.Name} className="featured-attribute-wrapper">
                                                <i className="fas fa-check"></i>
                                                <div className="featured-attribute">
                                                    {attr.Name}: <span dangerouslySetInnerHTML={{ __html: attr.Value }} />
                                                </div>
                                            </div>)
                                            )}
                                        </div>
                                    }
                                    {RestrictedShipToAreas.length > 0 && <div className="shipping-restrictions">
                                        <IconWithTooltip
                                            id={"shipping-restrictions-tooltip-" + DefaultVariationCode}
                                            icon="fa-solid fa-hexagon-exclamation"
                                            label={translateResourceString("/Shared/Products/ShippingRestrictionsLabel")}
                                            tooltip={translateResourceString("/Shared/Products/ShippingRestrictionsTooltip") + RestrictedShipToAreas.join(", ")}
                                            placement="bottom"
                                        />
                                    </div>}
                                </div>
                            </div>
                            <div className={"col-md-auto featured-product-with-variations__single-variation-column" + (showVariations ? " border-left-0 d-none d-md-block" : "")}>
                                {!showVariations &&
                                    <>
                                        <div className="">
                                            {!hidePrices && defaultVariation.PriceViewModel && !defaultVariation.HidePrice &&
                                                <div className="mb-1">
                                                    <>
                                                        {defaultVariation.PriceViewModel.IsSalePrice ? (
                                                            <div>
                                                                <span className="featured-product-with-variations__price">{defaultVariation.PriceViewModel.SalePrice} {translateResourceString("/Search/ProductTile/EachLabel")}</span>
                                                                <span className="featured-product-with-variations__old-price">{defaultVariation.PriceViewModel.RegularPrice} {translateResourceString("/Search/ProductTile/EachLabel")}</span>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                <span className="featured-product-with-variations__price">{defaultVariation.PriceViewModel.RegularPrice} {translateResourceString("/Search/ProductTile/EachLabel")}</span>
                                                            </div>
                                                        )}
                                                    </>
                                                </div>
                                            }

                                            {defaultVariation.ShowInventoryAvailable && (
                                                defaultVariation.IsInStock
                                                    ? <div className="stock mb-md-1">{translateResourceString("/Product/Index/InStock")}</div>
                                                    : <div className="stock out mb-md-1">{translateResourceString("/Product/Index/OutOfStock")}</div>
                                            )}
                                        </div>
                                        <div className="">
                                            <div className="featured-product-with-variations__actions">
                                                {!canAddToCart
                                                    ? <a className="btn btn-xs btn-neogen-green" href={Link} onClick={this.onProductClick}>{translateResourceString("/Search/ViewButton")}</a>
                                                    : <>
                                                        <label className='visually-hidden' htmlFor={qtyBoxId}>{translateResourceString("/Product/Tile/QuantityLabel")}</label>
                                                        <input className={qtyClassName} id={qtyBoxId} value={this.state.quantity} type="number" min={this.DefaultVariationMinimumOrderQuantity} step={this.DefaultVariationStepQuantity} onChange={this.handleQuantityChange} onKeyPress={this.handleKeyPress} aria-label={translateResourceString("/Product/AddToCart/QuantityLabel")} />
                                                        {isUserLoggedIn || !isOrderRequestOnlyMarket
                                                            ? <button className="btn btn-xs btn-neogen-green js-btn-add-to-cart-confirm" disabled={!validInput} onClick={() => this.onAddToCart(defaultVariation, this.state.quantity, this.onAddToCartSuccess)}>{translateResourceString("/Search/AddToCartButton")}</button>
                                                            : <a className="btn btn-xs btn-neogen-green" disabled={!validInput} href={this.state.addToCartLoginLink}>{translateResourceString("/Search/AddToCartButton")}</a>
                                                        }
                                                    </>
                                                }
                                                {!!defaultVariation.Code &&
                                                    <div className="list-button">
                                                        <ProductTileAddToListLink
                                                            linkClass={defaultVariation.addToListLinkClass}
                                                            isUserLoggedIn={isUserLoggedIn}
                                                            toggleModal={toggleAddToListModal}
                                                            variation={defaultVariation}
                                                            loginPageUrl={loginPageUrl}
                                                        />
                                                    </div>
                                                }
                                            </div>
                                            {canAddToCart &&
                                                <div>
                                                    {defaultVariation.MinimumOrderQuantity > 0 &&
                                                        <div className="mt-1">
                                                            <span>{translateResourceString("/ShoppingCart/Index/Item/MinQtyMessage").replace("{0}", defaultVariation.MinimumOrderQuantity)}</span>
                                                        </div>
                                                    }
                                                    {defaultVariation.EnforceCaseCount &&
                                                        <div className="mt-1">
                                                            <span>{translateResourceString("/ShoppingCart/Index/Item/CaseQtyMessage").replace("{0}", defaultVariation.CaseCount)}</span>
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {showVariations &&
                    <div className="featured-product-with-variations__footer">
                        <table className="table table-responsive-sm mb-0">
                            <thead>
                                <tr>
                                    <th scope="col" style={{ minWidth: "125px" }}>{translateResourceString("/Search/ProductTile/ItemNameHeader")}</th>
                                    {hasCatalogNumbers
                                        ? <th scope="col">{translateResourceString("/Shared/Products/ErpItemNumberLabel")} | {translateResourceString("/Shared/Products/CatalogNumberLabel")}</th>
                                        : <th scope="col">{translateResourceString("/Shared/Products/ErpItemNumberLabel")}</th>
                                    }
                                    {!hidePrices && <th scope="col">{translateResourceString("/Search/ProductTile/UnitPriceHeader")}</th>}
                                    {!hideInventory && <th scope="col" style={{ minWidth: "100px" }}>{translateResourceString("/Search/ProductTile/AvailabilityHeader")}</th>}
                                    <CustomTd scope="col" className={"d-none d-" + addToCartBreakpoint + "-table-cell"} style={{ borderTop: "0!important", minWidth: "180px" }}></CustomTd>
                                </tr>
                            </thead>
                            <tbody>
                                {(showMore ? Variations : Variations.slice(0, variationsToShow)).map((v) =>
                                    <ProductTileVariation
                                        key={v.MasterItemNumber + v.SKU}
                                        variation={v}
                                        hideInventory={hideInventory}
                                        hidePrices={hidePrices}
                                        onProductClick={this.onProductClick}
                                        onAddToCart={this.onAddToCart}
                                        wishlistData={wishlistData}
                                        toggleAddToListModal={toggleAddToListModal}
                                        addToCartBreakpoint={addToCartBreakpoint}
                                        loginPageUrl={loginPageUrl}
                                        isUserLoggedIn={isUserLoggedIn}
                                        isOrderRequestOnlyMarket={isOrderRequestOnlyMarket}
                                    />
                                )}
                            </tbody>
                        </table>
                        {Variations.length > variationsToShow &&
                            <div className="text-center">
                                <button className="btn btn-neogen-link" onClick={this.toggleShowMore}>
                                    {showMore
                                        ? <>{translateResourceString("/Search/ProductTile/ShowLessButton")} <i className="fas fa-caret-up"></i></>
                                        : <>{translateResourceString("/Search/ProductTile/ShowMoreButton")} <i className="fas fa-caret-down"></i></>
                                    }
                                </button>
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }
}

ProductTileWithVariations.propTypes = {
    Link: PropTypes.string,
    Name: PropTypes.string,
    Description: PropTypes.string,
    DefaultVariationCode: PropTypes.string,
    Image: PropTypes.shape({
        Url: PropTypes.string,
        Alt: PropTypes.string
    }),
    HidePricing: PropTypes.bool,
    IsTestingOrTestingStandaloneProduct: PropTypes.bool,
    ProceedLink: PropTypes.string,
    HasMultipleVariations: PropTypes.bool,
    FeaturedAttributes: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        Value: PropTypes.string,
        SortOrder: PropTypes.number
    })),
    RestrictedShipToAreas: PropTypes.arrayOf(PropTypes.string),
    Variations: PropTypes.arrayOf(PropTypes.shape({
        Link: PropTypes.string,
        Name: PropTypes.string,
        GtmName: PropTypes.string,
        SKU: PropTypes.string,
        Code: PropTypes.string,
        MasterItemNumber: PropTypes.string,
        PriceViewModel: PropTypes.shape({
            RegularPrice: PropTypes.string,
            SalePrice: PropTypes.string,
            IsSalePrice: PropTypes.bool
        }),
        CanAddToCart: PropTypes.bool,
        HidePrice: PropTypes.bool,
        ShowInventoryAvailable: PropTypes.bool,
        IsInStock: PropTypes.bool,
        GoogleTagManagerProductFieldObject: PropTypes.object,
        MinimumOrderQuantity: PropTypes.number,
        CaseCount: PropTypes.number,
        EnforceCaseCount: PropTypes.bool,
    })),
    addToCartEndPoint: PropTypes.string,
    listName: PropTypes.string,
    wishlistData: PropTypes.object,
    loginPageUrl: PropTypes.string,
    isUserLoggedIn: PropTypes.bool,
    isOrderRequestOnlyMarket: PropTypes.bool
};

export default ProductTileWithVariations;